<template>
  <div class="has-text-centered">
    <!-- Update button -->
    <button
      class="button is-text is-small"
      @click.prevent="handleEdit"
      :title="$t('users.update')"
    >
      <octicon :icon="pencil" />
    </button>

    <!-- Reset Password button -->
    <button
      class="button is-text is-small"
      @click.prevent="handleResetPassword"
      :title="$t('users.resetPassword')"
    >
      <octicon :icon="key" />
    </button>

    <!-- Activate/Deactivate button -->
    <button
      class="button is-text is-small"
      @click.prevent="handleToggleStatus"
      :title="user.status === 'active' ? $t('users.deactivate') : $t('users.activate')"
      :class="user.status === 'active' ? 'has-text-warning' : 'has-text-success'"
    >
      <octicon :icon="user.status === 'active' ? circleSlash : play" />
    </button>

    <!-- Force Logout button -->
    <!-- <button
      class="button is-text is-small has-text-danger"
      @click.prevent="handleForceLogout"
      :title="$t('users.forceLogout')"
      :disabled="isCurrentUser"
    >
      <octicon :icon="signOut" />
    </button> -->
  </div>
</template>

<script>
import { pencil, key, circleSlash, play, signOut } from 'octicons-vue'

export default {
  name: 'UserActions',
  props: {
    user: {
      type: Object,
      required: true
    },
    currentUserId: {
      type: String,
      default: null
    }
  },
  computed: {
    pencil() {
      return pencil
    },
    key() {
      return key
    },
    circleSlash() {
      return circleSlash
    },
    play() {
      return play
    },
    signOut() {
      return signOut
    },
    isCurrentUser() {
      return this.currentUserId && this.user.id === this.currentUserId
    }
  },
  methods: {
    /**
     * Emits edit event for the user
     */
    handleEdit() {
      this.$emit('edit', this.user)
    },
    /**
     * Emits reset password event for the user
     */
    handleResetPassword() {
      this.$emit('reset-password', this.user)
    },
    /**
     * Emits toggle status event for the user
     */
    handleToggleStatus() {
      this.$emit('toggle-status', this.user)
    },
    /**
     * Emits force logout event for the user
     */
    handleForceLogout() {
      this.$emit('force-logout', this.user)
    }
  }
}
</script>
